export const DEFAULT_TACTIC_API_URL = 'https://union.gettactic.com';
export const DEFAULT_TACTIC_DEFAULT_PROTOCOL = 'https';
export const DEFAULT_TACTIC_DOMAIN_AND_PORT = 'gettactic.com';
// Expected answers from the API: the user or the request is wrong, not the code.
// 400 stays out of this list on purpose, it usually means the client sent a bad request.
export const DEFAULT_EXCLUDE_SENTRY_STATUS_CODES = [
  401, 403, 404, 409, 410, 422, 429, 499
];
export const DEFAULT_TACTIC_AUTH_HEADER = '';
